var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"rounded-0 mt-0",attrs:{"variant":"light","block":"","size":_vm.$screen.lg ? 'lg' : 'sm'},on:{"click":_vm.chat}},[_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-message-dots","size":"lg"}}),_c('div',[_vm._v(" "+_vm._s(_vm.$t("Message"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }